/* -------------------------------------------------------------------------
 * Sayuri signature · tide-wave  (Pearl of Sendai)
 * -------------------------------------------------------------------------
 * Port of `TideWave` in the design file (line ~1153). Gentle horizontal
 * swells crossing the bottom of the viewport — stacked SVG waves at
 * progressively lower opacity, sliding sideways on two inverse cycles.
 *
 * Scent character: "Salt air at low tide, oyster shell, a cool linen
 * sleeve." Coastal + quiet + breath.
 * ----------------------------------------------------------------------- */
(function () {
  'use strict';
  var SA = window.SayuriAnimations;
  if (!SA) { return; }

  SA.register('tide-wave', {
    mount: function (el, ctx) {
      var n = ctx.intensity === 'lush' ? 5 : 3;
      var accent = ctx.accent;

      var frag = document.createDocumentFragment();
      for (var i = 0; i < n; i++) {
        var variant = i % 2;
        var bottom = (i * 20 - 30);
        var opacity = 0.18 - i * 0.03;
        var dur = 20 + i * 4;
        var yWave = 50 + i * 10;

        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('viewBox', '0 0 1440 200');
        svg.setAttribute('preserveAspectRatio', 'none');
        svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        svg.style.position = 'absolute';
        svg.style.left = '0';
        svg.style.right = '0';
        svg.style.bottom = bottom + 'px';
        svg.style.width = '200%';
        svg.style.height = '200px';
        svg.style.opacity = opacity;
        svg.style.animation = 'tide-' + variant + ' ' + dur + 's linear infinite';
        svg.innerHTML =
          '<path d="M0,100 Q360,' + yWave + ' 720,100 T1440,100 T2160,100 T2880,100 V200 H0 Z" fill="' + accent + '"/>';

        frag.appendChild(svg);
      }
      el.appendChild(frag);
    },
    css: [
      '@keyframes tide-0 { 0%{transform:translateX(0);} 100%{transform:translateX(-50%);} }',
      '@keyframes tide-1 { 0%{transform:translateX(-50%);} 100%{transform:translateX(0);} }'
    ].join('')
  });
})();
